export const tabs = {
	summary: "Summary",
	locationSummary: "LocationSummary",
	locationInfo: "LocationInfo",
	associations: "Associations",
	branches: "Branches",
	statusHistory: "StatusHistory",
	fieldAudits: "FieldAudits",
} as const;

export const modals = {} as const;

export type dynamicEditorPageName = (typeof tabs)[keyof typeof tabs] | (typeof modals)[keyof typeof modals];
export type PageNames = keyof typeof tabs;
